export default __webpack_public_path__ + "static/media/check-circle.af030d30.svg";